export default {"src":"/_next/static/media/tooth_40.4da2a29a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};